module.exports = __webpack_public_path__ + "static/img/n_5.82144580.png";